// extracted by mini-css-extract-plugin
export default {"button":"ButtonBase_button__rUdpI","div":"ButtonBase_div__YMZtQ"};